import { __assign, __read } from "tslib";
import { isNil } from '@antv/util';
/**
 * execute transition animation on element
 * @description in the current stage, only support the following properties:
 * x, y, width, height, opacity, fill, stroke, lineWidth, radius
 * @param el element to be animated
 * @param target target properties
 * @param options transition options
 * @param animate whether to animate
 * @returns transition instance
 */
export function transition(el, target, options) {
    var from = {};
    var to = {};
    Object.entries(target).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], tarStyle = _b[1];
        var currStyle = el.attr(key);
        if (!isNil(tarStyle) && !isNil(currStyle) && currStyle !== tarStyle) {
            from[key] = currStyle;
            to[key] = tarStyle;
        }
    });
    if (!options) {
        if ('update' in el)
            el.update(target);
        else
            el.attr(target);
        return null;
    }
    if (Object.keys(from).length > 0) {
        return el.animate([from, to], __assign({ fill: 'both' }, options));
    }
    return null;
}
//# sourceMappingURL=transition.js.map